import {AbstractContactModel} from './abstract-contact.model';
import {GtPhoneNumberUtil} from '../shared/utils/gt-phone-number.util';

export class PhonenumberEntry {
  constructor(public fullNumber?: string, public name?: string, public login?: string) {}

  static fromContactModel(contactModel: AbstractContactModel): PhonenumberEntry {
    return new PhonenumberEntry(contactModel.phoneNumber, contactModel.name, contactModel.login);
  }

  getDisplayNumber(): string {
    return GtPhoneNumberUtil.toDisplay(this.fullNumber);
  }

  getE164Number(): string {
    return GtPhoneNumberUtil.toE164(this.fullNumber);
  }

  getBackendNumber(): string {
    return GtPhoneNumberUtil.toBackend(this.fullNumber);
  }
}
